import CurrencyFormat from 'react-currency-format';

const  financial = (x,y) => {
  return Number.parseFloat(x).toFixed(y);
}
export default function  MoneyFormat ({value, suffix, addSuffix=true}){
    let numberAfterVirgul = 0 ;
    if (suffix && suffix != ' Ar') numberAfterVirgul = 2 ;
    
    let newValue = financial(value,numberAfterVirgul).replace(".", ",");
    return (<CurrencyFormat value={newValue} displayType={'text'} thousandSeparator={' '} decimalSeparator=',' suffix={addSuffix ? (suffix??' Ar') : ''} />);
}
